export const proofPoints = [
    { stat: '5.0★', label: 'Reviews.io rating · 52 reviews · 100% recommend' },
    { stat: '12K+', label: 'Live open tenders in the platform at any time' },
    { stat: '420K+', label: 'Historical contract awards for intelligence and benchmarking' },
    { stat: '£2Bn+', label: 'Public sector sales experience behind the platform' },
]